import type { FC } from "react";

import { Checkbox } from "@jti/core-components/components/Checkbox";
import { Controller, useFormContext } from "@jti/ui";

import type { CheckboxFieldConfig } from "@checkout-v2/formFields/components/CheckboxField/CheckboxField.types";

export type CheckboxProps = {
  fieldConfig: CheckboxFieldConfig;
  dataTestId?: string;
  onToggle?: (checked: boolean) => void;
};

export const CheckboxField: FC<CheckboxProps> = ({ fieldConfig, dataTestId, onToggle }) => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      control={control}
      name={fieldConfig.name}
      render={({ field }) => {
        const checked = typeof field.value === "object" ? field.value?.checked : field.value;

        return (
          <Checkbox
            {...field}
            checked={checked ?? false}
            id={fieldConfig.name}
            data-testid={dataTestId as string}
            name={fieldConfig.name}
            label={fieldConfig.labelHtml || fieldConfig.label}
            onCheckedChange={(nextChecked) => {
              setValue(fieldConfig.name, nextChecked);
              onToggle?.(nextChecked);
            }}
          />
        );
      }}
    />
  );
};
